<template>
    <section class="banner-section">
        <!-- 背景图片 -->
        <div class="banner-image-wrapper">
           
            <img src="https://images.leaflypackaging.com/upload/2026/04/13/banner_20260413223211A006.webp"
                 alt="Premium Custom Packaging Solutions"
                 class="banner-image"
                 fetchpriority="high"
                 loading="eager"
                 height="640" />
        </div>

        <!-- 遮罩层 -->
        <div class="banner-overlay"></div>

        <!-- 内容层 -->
        <div class="banner-content">
            <div class="container mx-auto px-3">
                <div class="content-wrapper">
                    <!-- 标题组 - 从上向下动画 -->
                    <div class="banner-title-group">
                        <h1 class="banner-title">
                            Tailor-Made Packaging for Every Brand
                        </h1>
                    </div>

                    <!-- 描述和按钮组 - 从下向上动画 -->
                    <div class="banner-bottom-group">
                        <p class="banner-description">
                            Create custom boxes & packaging of your dreams,Boost your profitability with Leaflypackaging as your packaging partner.
                        </p>

                        <!-- CTA 按钮组 -->
                        <div class="banner-cta">
                            <nuxt-link to="/custom-packaging" class="btn-primary" aria-label="Get a custom quote for your packaging needs">
                                Get A Quote
                                <svg class="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                </svg>
                            </nuxt-link>
                            <nuxt-link to="/packaging" class="btn-secondary" aria-label="Browse our packaging products">
                                Browse Products
                            </nuxt-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
// 无需额外的逻辑，所有样式和动画通过CSS实现
</script>

<style scoped lang="scss">
.banner-section {
    position: relative;
    width: 100%;
    height: 640px;
    overflow: hidden;
}

/* 背景图片容器 */
.banner-image-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
}

.banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;

    /* 移动端：显示右侧部分 */
    @media (max-width: 768px) {
        object-position: right center;
    }
}

/* 遮罩层 - 提高文字可读性 */
.banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, rgba(43, 43, 43, 0.5) 0%, rgba(83, 83, 83, 0.2) 50% rgba(255, 255, 255, 0.2) 100%);
    z-index: 1;

    @media (max-width: 768px) {
        background: linear-gradient(to right, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 100%);
    }
}

/* 内容容器 */
.banner-content {
    position: relative;
    z-index: 2;
    height: 100%;
    display: flex;
    align-items: center;
}

.content-wrapper {

    color: white;

    @media (max-width: 768px) {
        max-width: 100%;
    }
}

/* 标题组动画 - 从上向下 */
.banner-title-group {
    margin-bottom: 2rem;
    opacity: 0;
    animation: slideInDown 1s ease-out forwards;
    will-change: transform, opacity;
    backface-visibility: hidden;
    -webkit-font-smoothing: antialiased;

    @media (max-width: 768px) {
        margin-bottom: 1.5rem;
    }
}

/* 标题 */
.banner-title {
    font-size: 3.5rem;
    font-weight: 600;
    line-height: 1.1;
    margin-bottom: 1rem;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);

    @media (max-width: 1024px) {
        font-size: 2.75rem;
    }

    @media (max-width: 768px) {
        font-size: 2rem;
        margin-bottom: 0.75rem;
    }
}

/* 副标题 */
.banner-subtitle {
    font-size: 1.25rem;
    font-weight: 400;
    color: #fef9c3; /* 浅黄色，提高对比度 */
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);

    @media (max-width: 768px) {
        font-size: 1rem;
    }
}

/* 描述和按钮组动画 - 从下向上 */
.banner-bottom-group {
    opacity: 0;
    animation: slideInUp 1s ease-out 0.2s forwards;
    will-change: transform, opacity;
    backface-visibility: hidden;
    -webkit-font-smoothing: antialiased;
}

/* 描述文字 */
.banner-description {
    font-size: 1.5rem;
    line-height: 1.6;
    margin-bottom: 2rem;
    color: #f3f4f6;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
    max-width: 700px;
    @media (max-width: 768px) {
        font-size: 1rem;
        margin-bottom: 1.5rem;
    }
}

/* CTA 按钮组 */
.banner-cta {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 0.75rem;
    }
}

/* 主按钮 */
.btn-primary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 1rem 2rem;
    background: #059669;
    color: white;
    font-weight: 600;
    font-size: 1rem;
    border-radius: 0.5rem;
    text-decoration: none;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    &:hover {
        background: #047857;
        transform: translateY(-2px);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    }

    @media (max-width: 768px) {
        width: 100%;
        padding: 0.875rem 1.5rem;
    }
}

/* 次要按钮 */
.btn-secondary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 1rem 2rem;
    background: transparent;
    color: white;
    font-weight: 600;
    font-size: 1rem;
    border: 2px solid white;
    border-radius: 0.5rem;
    text-decoration: none;
    transition: all 0.3s ease;

    &:hover {
        background: white;
        color: #059669;
        transform: translateY(-2px);
        box-shadow: 0 6px 12px rgba(255, 255, 255, 0.2);
    }

    @media (max-width: 768px) {
        width: 100%;
        padding: 0.875rem 1.5rem;
    }
}

/* ===== 动画定义 ===== */

/* 从上向下滑入 */
@keyframes slideInDown {
    0% {
        opacity: 0;
        transform: translate3d(0, -50px, 0);
    }
    100% {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }
}

/* 从下向上滑入 */
@keyframes slideInUp {
    0% {
        opacity: 0;
        transform: translate3d(0, 50px, 0);
    }
    100% {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }
}
</style>
